import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuard } from './app/guards/auth.guard';
import { RoleGuard } from './app/guards/role.guard';
import { AdminGuard } from './app/guards/admin.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home'
      },
      {
        path: 'home',
        data: { animation: 'home' },
        loadComponent: () => import('src/app/pages/modulos/home/home.component').then((c) => c.HomeComponent)
      }, 
      {
        path: 'empleados',
        data: { animation: 'empleados' },
        loadComponent: () => import('src/app/pages/modulos/empleados/empleados.component').then((c) => c.EmpleadosComponent)
      }, 
      {
        path: 'empleados/:id',
        data: { animation: 'empleados' },
        loadComponent: () => import('src/app/pages/modulos/empleados/ver-empleado/ver-empleado.component').then((c) => c.VerEmpleadoComponent)
      },
      {
        path: 'reservas',
        canActivate: [RoleGuard],
        data: { animation: 'reservas' },
        loadComponent: () => import('src/app/pages/modulos/agenda/agenda.component').then((c) => c.AgendaComponent)
      },
      {
        path: 'agenda',
        canActivate: [RoleGuard],
        data: { animation: 'agenda' },
        loadComponent: () => import('src/app/pages/modulos/agenda/agenda.component').then((c) => c.AgendaComponent)
      },
      {
        path: 'reservas/listado',
        redirectTo: 'reservas',
        pathMatch: 'full'
      },
      {
        path: 'admin',
        canActivate: [AdminGuard],
        loadComponent: () => import('src/app/pages/modulos/admin/admin.component').then((c) => c.AdminComponent)
      },
      {
        path: 'admin/operativa',
        canActivate: [RoleGuard],
        data: { animation: 'admin-operativa' },
        loadComponent: () =>
          import('src/app/pages/modulos/admin/dashboards/operativa/operativa-dashboard.component').then(
            (c) => c.OperativaDashboardComponent
          )
      },
      {
        path: 'admin/diseno',
        canActivate: [AdminGuard],
        data: { animation: 'admin-diseno' },
        loadComponent: () =>
          import('src/app/pages/modulos/admin/dashboards/diseno/diseno-dashboard.component').then(
            (c) => c.DisenoDashboardComponent
          )
      },
      {
        path: 'admin/diseno/apariencia',
        canActivate: [AdminGuard],
        data: { animation: 'admin-apariencia' },
        loadComponent: () =>
          import('src/app/pages/modulos/admin/pages/apariencia/apariencia-admin.component').then(
            (c) => c.AparienciaAdminComponent
          )
      },
      {
        path: 'admin/links',
        canActivate: [AdminGuard],
        data: { animation: 'admin-links' },
        loadComponent: () =>
          import('src/app/pages/modulos/admin/pages/gestion-links/gestion-links.component').then(
            (c) => c.GestionLinksComponent
          )
      },
      {
        path: 'admin/servicios',
        canActivate: [AdminGuard],
        canDeactivate: [(component: { canLeave(): boolean }) => component.canLeave()],
        data: { animation: 'admin-servicios' },
        loadComponent: () => import('src/app/pages/modulos/servicios/servicios-admin.component').then(c => c.ServiciosAdminComponent)
      },
      {
        path: 'admin/empleados',
        canActivate: [AdminGuard],
        data: { animation: 'admin-personal' },
        loadComponent: () => import('src/app/pages/modulos/empleados/admin/empleados-admin.component').then(c => c.EmpleadosAdminComponent)
      },
      {
        path: 'admin/empleados/nuevo',
        canActivate: [AdminGuard],
        canDeactivate: [(component: { canLeave(): boolean }) => component.canLeave()],
        loadComponent: () => import('src/app/pages/modulos/empleados/admin/empleado-editor-page.component').then(c => c.EmpleadoEditorPageComponent)
      },
      {
        path: 'admin/empleados/:id/editar',
        canActivate: [AdminGuard],
        canDeactivate: [(component: { canLeave(): boolean }) => component.canLeave()],
        loadComponent: () => import('src/app/pages/modulos/empleados/admin/empleado-editor-page.component').then(c => c.EmpleadoEditorPageComponent)
      },
      {
        path: 'admin/paginas',
        canActivate: [AdminGuard],
        data: { animation: 'admin-paginas' },
        loadComponent: () =>
          import('src/app/pages/modulos/admin/pages/gestion-paginas/gestion-paginas.component').then(
            (c) => c.GestionPaginasComponent
          )
      },
      {
        path: 'admin/home',
        canActivate: [AdminGuard],
        data: { animation: 'admin-home-cms' },
        loadComponent: () =>
          import('src/app/pages/modulos/admin/forms/home-cms-admin/home-cms-admin.component').then(
            (c) => c.HomeCmsAdminComponent
          )
      },
      {
        path: 'admin/configuracion',
        canActivate: [AdminGuard],
        data: { animation: 'admin-configuracion' },
        loadComponent: () =>
          import('src/app/pages/modulos/admin/forms/topbar-cms-admin/topbar-cms-admin.component').then(
            (c) => c.TopbarCmsAdminComponent
          )
      },
      {
        path: 'admin/topbar',
        redirectTo: 'admin/configuracion',
        pathMatch: 'full'
      },
      {
        path: 'clientes',
        canActivate: [RoleGuard],
        loadComponent: () => import('src/app/pages/modulos/clientes/clientes.component').then((c) => c.ClientesComponent)
      },
      {
        path: 'usuarios',
        canActivate: [AdminGuard],
        data: { animation: 'usuarios' },
        loadComponent: () =>
          import('src/app/pages/modulos/usuarios/gestion-usuarios/gestion-usuarios.component').then(
            (c) => c.GestionUsuariosComponent
          )
      },
      { path: '404', component: Notfound, title: 'AGENCIA - 404 No encontrado' },
      { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes'), title: 'AGENCIA - Login' },

      {
        path: '**',
        data: { animation: 'page' },
        loadComponent: () => import('src/app/pages/modulos/pagina/pagina.component').then((c) => c.PaginaComponent)
      }
    ]
  },
  // { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes'), title: 'AGENCIA - Login' },
  // { path: '**', component: Notfound, title: 'AGENCIA - 404 No encontrado' }
];
